<template>
  <div class="product-page" id="page" v-cloak>
    <!-- <navbar v-show="isTop == false"></navbar> -->
    <div v-if="isTop == false" class="h-nav-item" @click="onClickLeft">
      <van-icon name="arrow-left" />
    </div>

    <van-nav-bar v-if="isTop" title="商品详情" fixed left-arrow @click-left="onClickLeft" @click-right="goHome">
      <template #right>
        <van-icon name="wap-home-o" size="18" />
      </template>
    </van-nav-bar>

    <!-- 轮播图 -->
    <van-swipe class="swiper-block" indicator-color="white">
      <van-swipe-item v-for="(item, index) in productInfo.pic_list" :key="index">
        <!-- <img class="swiper-img" :src="item" alt="" /> -->
        <van-image class="swiper-img" :src="item" @click="imagePreview(productInfo.pic_list,index)">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>

    <!-- 商品名 -->
    <div class="goods-info">
      <div class="goods-price">
        <div class="price">
          <span class="price-icon">¥</span>{{ productInfo.shop_price || 0 | numToCash  }}
          <span class="original-price">市场价¥{{ productInfo.market_price || 0 | numToCash  }}</span>
        </div>
        <div class="sold">已售{{ productInfo.sales_sum }}</div>
      </div>

      <div class="goods-desc-block">
        <div class="goods-name">
          <van-tag class="column-goods-img-leble" color="#ff5000" type="primary" size="large" v-if="productType == 1">礼券</van-tag>
          <van-tag class="column-goods-img-leble" color="#00A8C0" type="primary" size="large" v-if="productType == 2">积分</van-tag>
          <!-- <van-tag color="#ff5000" type="primary" size="medium">推荐</van-tag> -->
          {{ productInfo.brand_name }}
          {{ productInfo.goods_name }}
        </div>
        <!-- <div class="goods-desc">{{ productInfo.description }}</div> -->
      </div>
    </div>

    <!-- cell -->
    <div class="goods-cell" @click="onSku">
      <div class="cell-tips">参数</div>
      <div class="cell-center">{{skusItem.spec_value}}*{{amount}}</div>
    </div>
    <!-- 所在省市 -->
    <div class="goods-cell" v-if="productInfo.province_name">
      <div class="cell-tips">所在地</div>
      <div class="cell-center">{{productInfo.province_name}}-{{productInfo.city_name}}</div>
    </div>

    <!-- <div class="goods-cell" @click="goExpressRule()"> -->
    <div class="goods-cell" v-if="Number(productInfo.express_price) > 0 ">
      <div class="cell-tips">配送</div>
      <div class="cell-center"> {{ productInfo.express_price }}</div>
      <!-- <div class="cell-center" v-else>包邮 <span style=" font-size: 10px;">(部分地区)</span> </div> -->
    </div>

    <div class="goods-cell mb5" v-if="productInfo.province_name">
      <div class="cell-tips">所在地</div>
      <div class="cell-center-n"> {{ productInfo.province_name }}-{{ productInfo.city_name }} </div>
    </div>

    <!-- 评价 暂时隐藏 -->
    <!-- <div class="goods-cell mb15" @click="goPage({name:'comment-see',query:{id:productInfo.state}})">
        <div class="cell-tips">评价</div>
        <div class="cell-center">用户点评（50条）</div>
      </div> -->

    <!-- 猜你喜欢 -->
    <!-- {{mobile}} -->
    <!-- <you-like-scroll v-if="mobile"></you-like-scroll> -->

    <!-- 图片详情 -->
    <div class="goods-title">-商/品/详/情-</div>

    <div class="center-b" v-html="productInfo.goods_content">

    </div>

    <!-- <div class="goods-img-d">
        <img v-for="(item, index) in productInfo.details" :key="index" class="img-d" mode="widthFix" :src="item" />
      </div> -->

    <!-- 底部按钮 -->
    <van-goods-action :safe-area-inset-bottom="true">
      <!-- <van-goods-action-icon icon="chat-o" text="咨询" @click="onIsChat" /> -->
      <!-- <van-goods-action-icon v-if="isCollection" icon="star" text="已收藏" color="#ff5000" @click="onCollection()" /> -->
      <!-- <van-goods-action-icon v-else icon="star-o" text="收藏" @click="onCollection()" /> -->
      <!-- <van-goods-action-icon icon="shopping-cart-o" text="购物车" :badge="cartNum" @click="goShoopCart()" /> -->
      <!-- <van-goods-action-button color="#ff510093" type="warning" text="加入购物车" @click="onSku" /> -->
      <van-goods-action-button color="#ff5000" type="danger" text="立即购买" @click="onSku" />
    </van-goods-action>

    <van-popup v-model="isSku" position="bottom" closeable close-icon="close" :style="{ height: '80%' }">
      <div class="sku-block">
        <!-- 详情 -->
        <div class="sku-header">
          <div class="sku-img-block">
            <van-image class="sku-img" :src="skusItem.pic" @click="imagePreview([skusItem.pic],0)" />
          </div>
          <div class="sku-info">
            <div class="sku-price">¥{{ skusItem.shop_price }}</div>
            <div class="original-price">¥{{ skusItem.market_price }}</div>
            <div class="sku-desc" v-if="oneSku == 1&&skusItem.spec_value">{{ skusItem.spec_value }}</div>
            <div class="sku-desc" v-if="oneSku == 2&&skusItem.spec_value">{{ skusItem.spec_value }}</div>

          </div>
        </div>

        <div class="sku-center-block">
          <!-- 选择 -->
          <!-- <div class="sku-radio mt20 plr20" v-if="productInfo.specs&&productInfo.specs.length > 0">
            <div class="sku-radio-name">{{ productInfo.specs[0].spec_name }}</div>
            <div v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['radio', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              {{ ita.spec_value }}
            </div>
          </div>

          <div class="sku-radio mt20 plr20" v-if="productInfo.specs && productInfo.specs.length > 1">
            <div class="sku-radio-name">{{ productInfo.specs[1].spec_name }}</div>
            <div v-for="(itb, idxb) in productInfo.specs[1].spec_sub" :key="idxb" :class="['radio', specIndex == idxb ? 'radio-active' : '']" @click="getSpec(idxb, itb)">
              {{ itb.spec_value }}
            </div>
          </div> -->
          <!-- 单规格 -->
          <div class="sku-radio mt20 plr20" v-if="oneSku == 1&& productInfo.specs">
            <div class="sku-radio-name">{{ productInfo.specs[0].spec_name }}</div>
            <div v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['one-df-sku radio ', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              <van-image class="img" width="30" height="30" :src="ita.pic" />
              {{ ita.spec_value }}
            </div>
          </div>

          <!-- 多规格 -->
          <div class="sku-radio mt20 plr20" v-if="oneSku == 2&&productInfo.specs&&productInfo.specs.length > 0">
            <div class="sku-radio-name" v-show="productInfo.specs[0].spec_sub[0].spec_value != '默认'">{{ productInfo.specs[0].spec_name }}</div>
            <div v-show="ita.spec_value != '默认'" v-for="(ita, idxa) in productInfo.specs[0].spec_sub" :key="idxa" :class="['radio', colorIndex == idxa ? 'radio-active' : '']" @click="getColor(idxa, ita)">
              {{ ita.spec_value }}
            </div>
          </div>

          <div class="sku-radio mt20 plr20" v-if="oneSku == 2&&productInfo.specs && productInfo.specs.length > 1">
            <div class="sku-radio-name">{{ productInfo.specs[1].spec_name }}</div>
            <div v-for="(itb, idxb) in productInfo.specs[1].spec_sub" :key="idxb" :class="['radio', specIndex == idxb ? 'radio-active' : '']" @click="getSpec(idxb, itb)">
              {{ itb.spec_value }}
            </div>
          </div>

          <div class="goods-num" v-if="productType == 1">
            <!-- 礼券 -->
            <p class="num-title">数量 <span>礼券：1，限购：1</span></p>
            <van-stepper v-model="amount" theme="round" :disabled="true" button-size="22" disable-input />
          </div>
          <div class="goods-num" v-if="productType == 2">
            <!-- //积分  -->
            <p class="num-title">数量 <span>积分：{{expoints}}，限购：{{limitAmount}}</span></p>
            <van-stepper v-model="amount" theme="round" :max="limitAmount" :min="1" button-size="22" disable-input />
          </div>
        </div>

        <div class="sku-btn-block">
          <!-- <div class="sku-btn-left btnC" @click="addShoopCart()">加入购物车</div> -->
          <div class="sku-btn-right btnC" @click="goPay()">立即购买</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="isChatPup" position="bottom" round>
      <div class="sku-block">
        <van-field v-model="chatContent" rows="8" autosize label="问题内容" type="textarea" maxlength="200" placeholder="请输入您要咨询的问题。" show-word-limit />
        <div class="sku-btn-block">
          <div class="sku-btn-left btnC" @click="onIsChat()">取 消</div>
          <div class="sku-btn-right btnC" @click="pushChat()">提 交</div>
        </div>
      </div>
    </van-popup>

    <!-- 系统公告 -->
    <!-- <zdyx-notice-pop :countDownPopShow.sync="isNoticeShow" :noticeTitle="noticeTitle" :noticeMessage="noticeMessage" @setPopShow="setPopShow"></zdyx-notice-pop> -->

  </div>
</template>
  
  <script>
var mrSKU = [
  {
    spec_id: 0,
    spec_name: "规格",
    spec_sub: [
      {
        spec_value: "默认",
        spec_value_id: 0,
      },
    ],
  },
];

import { ImagePreview } from "vant";
//    this.$router.push({ path: `/product-details/${even.r_id}` });
// import zdyxNoticePop from "@/components/notice-pop/notice-pop.vue";
import navbar from "@/components/navbar/navbar.vue";
// import youLikeScroll from "@/components/you-like-scroll/you-like-scroll.vue";
import sdk from "../../utils/wechart"; //引入sdk.js
export default {
  name: "ProductList",
  components: {
    navbar,
    // youLikeScroll ,
    // zdyxNoticePop
  },
  props: {},
  data() {
    return {
      productId: this.$route.query.goods_id,
      company_id: this.$route.query.company_id,
      productType: this.$route.query.type,
      productInfo: {},

      aa: {},
      time: 60 * 60 * 12 * 1000,
      isTop: false,
      isCollection: false, //收藏
      amount: 1, //商品数量步进器

      oneSku: 1, // 1 单规格  2 多规格 3 没有规格
      //   goods: {},
      isSku: false, //sku弹窗
      skusItem: {
        pic: "",
        sku_id: "", //商品skuid
        spec_value_ids: "", //商品规格值id，多个逗号隔开
        market_price: "", //市场价
        shop_price: "", //销售价
        stock: "", //库存
        spec_value: "", //规格值内容
      },
      colorIndex: 0,
      specIndex: 0,
      // CombinedSkuIndex: 0, //组合商品
      disabled: false,
      // 双规格时两个都赋值
      colorSku: "",
      specSku: "",
      // CombinedSku: "",

      cartNum: 0, //购物车数量

      isChatPup: false, // 咨询弹窗
      chatContent: "", //咨询内容

      expoints: 0,
      limitAmount: 1,
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.getScroll);
    this.init();
    if (!this.isLogin()) return false;
    // this.isWish(); // 是否已收藏
    // this.getShoppingCart(); // 购物车数量
    this.getPoints(); // 购物车数量
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    imagePreview(list, index) {
      ImagePreview({
        //图片预览
        images: list, //需要预览的图片 URL 数组
        showIndex: true, //是否显示页码
        loop: false, //是否循环播放
        startPosition: index, //图片预览起始位置索引
        closeable: true, //是否显示关闭图标
        // showIndicators: true, //	是否显示轮播指示器
      });
    },
    // 获取用户积分
    getPoints() {
      let _this = this;

      this.$toast.loading();
      _this.$post("/api/balance").then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.clear();
          _this.expoints = res.data.data.expoints || 0; //积分

          // limitAmount //数量
          if (this.productType == 2) {
            if (res.data.data.expoints > _this.productInfo.shop_price) {
              // console.log(res.data.data.expoints / _this.productInfo.shop_price, '原数')
              // console.log( Math.floor(res.data.data.expoints / _this.productInfo.shop_price) , '向下')
              // console.log( Math.ceil(res.data.data.expoints / _this.productInfo.shop_price) , '向上')
              // console.log( Math.trunc(res.data.data.expoints / _this.productInfo.shop_price) , '舍弃小数取整')

              this.limitAmount = Math.trunc(
                res.data.data.expoints / _this.productInfo.shop_price
              ); //向下取整
            } else {
              this.limitAmount = 1;
            }
          } else {
            this.limitAmount = 1;
          }

          this.productInfo.shop_price;
        }
      });
    },
    // 初始化商品详情数据
    init() {
      let _this = this;
      this.$toast.loading();
      let data = {
        company_id: this.company_id,
        type: this.productType,
        goods_id: this.productId,
      };
      _this.$post("/api/birth_goods_detail", data, data).then((res) => {
        console.log(res.data);
        if (res.data && res.data.code == 0) {
          // console.log(res.data.data);
          _this.productInfo = res.data.data;

          _this.productInfo.goods_content = _this.formatRichText(
            res.data.data.goods_content
          );

          _this.isCollection = res.data.data.isCollected > 0 ? true : false;

          if (res.data.data.specCombs.length < 1) {
            _this.oneSku = 3; // 1 单规格  2 多规格 3 没有规格
            // 没有规格
            _this.productInfo.specCombs = [
              {
                pic: res.data.data.pic || "",
                market_price: res.data.data.market_price, // 市场价
                shop_price: res.data.data.shop_price, //销售价
                sku_id: 0,
                spec_value: "默认",
                spec_value_ids: 0,
                stock: res.data.data.stock, //库存
              },
            ];
            // console.log(mrSKU)
            _this.productInfo.specs = mrSKU;
            // _this.CombinedSku = res.data.data.specCombs[0].spec_value;
            // return;
          }

          if (_this.productInfo.specs.length > 1) {
            _this.oneSku = 2; // 1 单规格  2 多规格 3 没有规格
            _this.productInfo.specCombs.map((item, index) => {
              if (item.pic == "" || item.pic == undefined || item.pic == null) {
                item.pic = _this.productInfo.pic;
              }
            });
            //  双规格时两个都赋值
            _this.colorSku = _this.productInfo.specs[0].spec_sub[0].spec_value;
            _this.specSku = _this.productInfo.specs[1].spec_sub[0].spec_value;
          } else {
            // console.log(_this.productInfo)
            // console.log(_this.productInfo.specs)
            //  单规格
            _this.oneSku = 1; // 1 单规格  2 多规格 3 没有规格
              // 先往 单规格的sku里塞图片
              _this.productInfo.specs[0].spec_sub.map((item, index) => {
              _this.productInfo.specCombs.find((value, index, arr) => {
                if (value.spec_value == item.spec_value) {
                  // console.log("一样", item);
                  // console.log("二样", value);
                  value.pic = value.pic || _this.productInfo.pic;
                  item = Object.assign(item, {
                    pic: value.pic || _this.productInfo.pic,
                  });
                }
              });
            });

            _this.colorSku = _this.productInfo.specs[0].spec_sub[0].spec_value;
          }
          _this.skusItem = _this.productInfo.specCombs[0];
          _this.$toast.clear();

          // _this.getNotice(_this.productId);
          // _this.shareDetail(res.data.data);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    //监听滚动
    getScroll() {
      this.indexNumTop = $("#page").offset().top;
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //   console.log(window.pageYOffset ||  document.documentElement.scrollTop ||  document.body.scrollTop)
      if (
        !!document.documentElement.scrollTop &&
        document.documentElement.scrollTop >= 200
      ) {
        // 设置滚动大于300时的执行内容
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
    // 关闭SKU弹窗
    onSku() {
      this.isSku = !this.isSku;
    },
    // 返回首页
    goHome() {
      this.$router.replace({
        name: "index",
        query: {},
      });
    },
    //   客服
    onIsChat() {
      this.chatContent = undefined;
      this.isChatPup = !this.isChatPup;
      // this.MakeCall(); //拨打电话
    },
    // 提交咨询
    pushChat() {
      let _this = this;
      let params = {
        goods_id: _this.productId,
        content: _this.chatContent,
      };
      _this.$post("/api/user_consult_add", params, params).then((res) => {
        // console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.success(res.data.message);
          _this.onIsChat();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 跳运费说明
    goExpressRule() {
      this.$router.push({
        name: "express-rule",
        query: {},
      });
    },
    // 跳购物车
    goShoopCart() {
      this.$router.push({
        name: "shopping-car",
        query: {},
      });
    },
    // // 跳猜你喜欢列表
    // goLikeList() {
    //   this.$router.push({
    //     name: "like-list",
    //     query: {},
    //   });
    // },
    // 加购物车
    addShoopCart() {
      let _this = this;
      if (!this.isLogin()) return false;
      // if (this.skusItem.state == 0) {
      //   _this.$toast.fail("该规格已下架！");
      //   return;
      // }
      let params = {
        goods_id: _this.productId,
        sku_id: _this.skusItem.sku_id,
        goods_num: _this.amount,
      };
      // goods_id:商品id
      // goods_num:数量和现有购物车数量累加
      // sku_id:skuid
      // console.log(this.amount)
      // console.log(this.skusItem.sku_id)
      _this.$post("/api/add_cart", params, params).then((res) => {
        // console.log(res.data);
        if (res.data.code == 0) {
          _this.$toast.success("添加购物车成功！");
          _this.onSku();
          _this.getShoppingCart();
        } else {
          _this.$toast.fail(res.data.message);
        }
      });

      //
    },
    onClickLeft() {
      let beforeLoginUrl = Lockr.get("beforeLoginUrl")
        ? JSON.parse(Lockr.get("beforeLoginUrl"))
        : "";
      let oldUrl = Lockr.get("oldUrl") ? Lockr.get("oldUrl") : "";

      // console.log(beforeLoginUrl)

      if (!beforeLoginUrl) {
        if (window.history.length <= 1) {
          this.$router.replace({
            name: "index",
            query: {},
          });
          return false;
        } else {
          this.$router.go(-1);
        }
      } else if (
        beforeLoginUrl.name == "product-details" &&
        oldUrl.name == "product-details"
      ) {
        this.$router.replace({
          name: "index",
          query: {},
        });
        // console.log(oldUrl.name)
        // console.log(beforeLoginUrl.name)
      }

      // console.log(window.history.length, 'w')
    },
    // getCombinedSkus(ind, e) {
    //   // 颜色
    //   let _this = this;

    //   _this.CombinedSkuIndex = ind;
    //   _this.CombinedSku = e.skuValCode;
    //   _this.skusItem = e;
    //   // this.getOneSkuCode(e.skuValCode);
    // },
    getColor(ind, e) {
      // 颜色
      let _this = this;

      _this.colorIndex = ind;
      _this.colorSku = e.spec_value;

      // 判断单双规格
      if (_this.productInfo.specs.length > 1) {
        // 双
        this.getSkuCode(e.spec_value, this.specSku);
      } else {
        // 单
        this.getOneSkuCode(e.spec_value);
      }
    },
    getSpec(index, e) {
      // 规格
      console.log(index, e.spec_value, this.colorSku);
      let _this = this;
      _this.specIndex = index;
      _this.specSku = e.spec_value;

      this.getSkuCode(this.colorSku, e.spec_value);
    },
    // 单规格
    getOneSkuCode(e) {
      let _this = this;
      _this.productInfo.specCombs.map((item, index) => {
        if (item.spec_value == e) {
          _this.skusItem = item;
        }
      });
    },
    // 双规格
    getSkuCode(a, b) {
      let _this = this;
      let s = a + "," + b;
      let ss = b + "," + a;

      console.log(s, "1样");
      _this.productInfo.specCombs.map((item, index) => {
        if (item.spec_value == s || item.spec_value == ss) {
          console.log(s, item, "2样");
          _this.skusItem = item;
        }
      });
    },
    // 跳确认订单
    goPay() {
      let _this = this;
      if (!this.isLogin()) return false;

      //  Lockr.set("goodsInfo", obj);

      // console.log(this.skusItem);

      // if (this.skusItem.state == 0) {
      //   _this.$toast.fail("该规格已下架！");
      //   return;
      // }

      // let data = {
      //   goods_name: "商品名称",
      //   activity_type: "类型；1普通 2礼券 3积分 4兑换",
      //   stock: "库存",
      //   market_price: "市场价",
      //   shop_price: "价格",
      //   express_price: "快递费",
      //   pic: "主图片",
      //   brand_name: "品牌名称",
      //   province_name: "所在省",
      //   city_name: "所在市",

      //   goods_sn: "商品编号",
      //   click_count: "点击数",
      //   goods_content: "内容",
      //   pic_list: "图片列表",
      //   sales_sum: "销量",
      //   collect_sum: "收藏数",
      //   comments: "评论",
      //   spec_open: "1=多规格商品",
      //   isCollected: "用户是否已收藏",
      //   allCommentCount: "评论数量",
      //   consults: "咨询",
      //   consultCount: "咨询数量",
      //   specs: [
      //     {
      //       spec_id: "规格id",
      //       spec_name: "规格名称",
      //       spec_sub: [
      //         {
      //           spec_value_id: "规格值id",
      //           spec_value: "规格值内容",
      //         },
      //       ],
      //     },
      //   ],
      //   specCombs: [
      //     {
      //       sku_id: "商品skuid",
      //       spec_value_ids: "商品规格值id，多个逗号隔开",
      //       market_price: "市场价",
      //       shop_price: "销售价",
      //       stock: "库存",
      //       spec_value: "规格值内容",
      //     },
      //   ],

      // };
      let obj = Object.assign(
        {
          cart_id: "0",
          goods_name: _this.productInfo.goods_name, //商品名称
          activity_type: _this.productInfo.activity_type, // 类型；1普通 2礼券 3积分 4兑换
          express_price: _this.productInfo.express_price, // 快递费
          // pic: _this.productInfo.pic, // 主图片
          brand_name: _this.productInfo.brand_name, // 品牌名称
          province_name: _this.productInfo.province_name, // 所在省
          city_name: _this.productInfo.city_name, // 所在市
          goods_id: _this.productId,
          amount: _this.amount,
          company_id: _this.company_id,
          type: _this.productType,
          limitAmount: _this.limitAmount,
        },
        this.skusItem
      );
      // console.log(this.skusItem, 'this.skusItem')
      // console.log(obj);
      Lockr.set("birthConfirmGoodsInfo", [obj]);
      this.$router.push({
        name: "birth-confirm-order",
        query: {
          company_id: _this.company_id,
          type: _this.productType,
        },
      });
    },
    // 分享商品
    shareDetail(Product) {
      let _this = this;
      // console.log(Product.images[0])
      let logo =
        "https://qiniu.zdyxjx.com/v3/pic/f30e30f2205a497f93351666655bc56c.png";
      let menuList = [
        "menuItem:share:qq", //分享到QQ
        "menuItem:share:weiboApp", // 分享到Weibo
        "menuItem:favorite", // 收藏
        "menuItem:share:QZone", // 分享到 QQ 空间
        "menuItem:copyUrl", // 复制链接
        "menuItem:openWithQQBrowser", // 在QQ浏览器中打开
        "menuItem:openWithSafari", // 在Safari中打开
        "menuItem:share:email", // 邮件
        "menuItem:readMode", // 阅读模式
        "menuItem:originPage", // 原网页
      ];
      var url = window.location.href.split("#")[0];

      let params = "?productId=" + Product.id;
      var obj = {
        title: Product.name || "百分百生活馆", //document.title, //分享标题
        desc: Product.description || "莫问前程  只问东西", //分享内容
        linkurl:
          location.protocol +
          "//" +
          location.host +
          "/html/#/product-details" +
          params,
        img: Product.images[0] || logo, //分享内容显示的图片
      };
      sdk.getJSSDK(url, obj, menuList);
    },
    // 是否已收藏
    // isWish() {
    //   let _this = this;
    //   this.$toast.loading();
    //   _this.$get("/product/api/Wish/State/" + _this.productId).then((res) => {
    //     // console.log(res.data);
    //     if (res.data.code == 200) {
    //       _this.isCollection = res.data.data > 0 ? true : false;
    //       // console.log(res.data.data, '是否已收藏'); //状态, 是否收藏，== 0：没有，> 0:已
    //       _this.$toast.clear();
    //     } else {
    //       _this.$toast.fail(res.data.message);
    //     }
    //   });
    // },
    // 修改收藏状态
    onCollection() {
      let _this = this;
      if (!this.isLogin()) return false;
      this.$toast.loading();
      let data = {
        goods_id: _this.productId,
      };
      if (_this.isCollection) {
        // 取消收藏
        _this.$post("/api/goods_collect", data, data).then((res) => {
          // console.log(res.data);
          if (res.data.code == 0) {
            _this.isCollection = !_this.isCollection;
            _this.$toast.success("取消收藏成功");
          } else {
            _this.$toast.fail(res.data.message);
            // _this.$toast.clear();
          }
        });
      } else {
        // 新增收藏
        _this.$post("/api/goods_collect", data, data).then((res) => {
          // console.log(res.data);
          if (res.data.code == 0) {
            _this.isCollection = !_this.isCollection;
            _this.$toast.success("收藏成功");
          } else {
            _this.$toast.fail(res.data.message);
          }
        });
      }
    },

    // 购物车数量
    getShoppingCart() {
      let _this = this;
      _this.$post("/api/cart_list").then((res) => {
        // console.log(res.data);
        if (res.data.code == 0) {
          // console.log(res.data.data.total);
          _this.cartNum = res.data.data.length || 0;
          // _this.cartNum = 0;
        }
      });
    },

    // getNotice(id) {
    //   let _this = this;
    //   _this.$get("notice/api/notice/productnotice/" + id).then((res) => {
    //     console.log(res.data, "notice");
    //     if (res.data && res.data.code == 200) {
    //       if (!res.data.data.content) return;
    //       this.isNoticeShow = true;
    //       this.noticeTitle = res.data.data.title;
    //       this.noticeMessage = res.data.data.content;
    //       this.noticeContent = res.data.data.content;
    //     }
    //   });
    // },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        // match = match
        //   .replace(/src="([^"]+)"/gi, 'src="http://xiche.yiro.top$1"')
        //   .replace(/src='([^']+)'/gi, 'src="http://xiche.yiro.top$1"');
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );

      return newContent;

      //
    },
  },
};
</script>
  
  <style lang="scss">
// 轮播图 图标颜色
.product-page {
  .van-swipe__indicators {
    .van-swipe__indicator--active {
      background-color: #ff5000 !important;
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff5000 !important;
      border-color: #ff5000 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff5000 !important;
    }
  }
}
</style>
  
  <style lang="scss" scoped>
.mb5 {
  margin-bottom: 5px;
}
.mb15 {
  margin-bottom: 15px;
}
.product-page {
  //   height: 100%;
  width: 100%;
  background-color: #f9f9f9;
  padding: 0 0 50px 0;

  //   -webkit-overflow-scrolling: touch;
  //   overflow-x: hidden;
  //   overflow-y: scroll;
  //   -ms-overflow-style: none; /* IE */
  //   scrollbar-width: none; /* Firefox */

  .swiper-block {
    height: 375px;
    width: 100%;
    background-color: #fff;
    .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #fff;

      .swiper-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .center-b {
    padding: 15px;
    font-size: 13px;
    text-align: left;
    p {
      text-indent: 2em;
    }
    img {
      display: block;
      width: 100%;
    }
  }

  //限时活动
  // .goods-time {
  //   height: 57px;
  //   width: 100%;
  //   padding: 0 10px;
  //   background-image: url("https://qiniu.zdyxjx.com/minizdyxgoods-bg.png");
  //   background-repeat: no-repeat;
  //   background-size: 100% 100%;
  //   background-position: 0 0;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   // background-color: palegreen;
  //   .goods-time-price {
  //     width: 50%;
  //     height: 100%;
  //     text-align: left;
  //     display: flex;

  //     flex-direction: column;
  //     justify-content: space-between;
  //     padding: 5px 0;
  //     //   justify-content: center;
  //     .original-price {
  //       font-size: 14px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       line-height: 17px;
  //       color: #eeeeee;
  //       span {
  //         margin-left: 8px;
  //         text-decoration: line-through;
  //         font-size: 10px;
  //       }
  //     }
  //     .price {
  //       span {
  //         font-size: 12px;
  //       }
  //       font-size: 24px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       // line-height: 30px;
  //       color: #ffffff;
  //       letter-spacing: 1px;
  //     }
  //   }
  //   .goods-time-date {
  //     width: 50%;
  //     height: 100%;
  //     text-align: right;
  //     display: flex;
  //     flex-direction: column;
  //     justify-content: space-between;
  //     padding: 5px 0;

  //     .tips {
  //       margin-bottom: 2px;
  //       font-size: 12px;
  //       font-family: Source Han Sans CN;
  //       font-weight: 500;
  //       line-height: 21px;
  //       color: #ffffff;
  //       letter-spacing: 1px;
  //     }
  //     .colon {
  //       display: inline-block;
  //       margin: 0 4px;
  //       color: #fff;
  //     }
  //     .block {
  //       display: inline-block;
  //       width: 22px;
  //       color: #fff;
  //       font-size: 12px;
  //       text-align: center;
  //       border-radius: 5px;
  //       border: 1px solid #fff;
  //       // background-color: #ee0a24;
  //     }
  //   }
  // }
  //商品名
  .goods-info {
    // min-height: 107px;
    width: 100%;
    padding: 0 15px 15px;
    margin-bottom: 5px;
    //   background-image: url("https://qiniu.zdyxjx.com/minizdyxgoods-bg.png");
    //   background-repeat: no-repeat;
    //   background-size: 100% 100%;
    //   background-position: 0 0;
    background-color: #ffffff;

    .goods-price {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 41px;
      color: #ff5000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price-icon {
        font-size: 12px;
      }
      .original-price {
        text-decoration: line-through;
        font-size: 12px;
        color: #78849e;
        margin-left: 10px;
      }
      .sold {
        color: #707070;
        font-size: 12px;
      }
    }

    .goods-desc-block {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      // color: #eeeeee;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;

      .goods-name {
        color: #2a2e43;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: 1px;
        text-align: left;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .goods-desc {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 21px;
        color: #707070;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
  }
  /* cell */
  .mb10 {
    margin-bottom: 10px;
  }
  .goods-cell {
    min-height: 44px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
  }

  .cell-tips {
    width: 15%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-right: 50rpx; */
  }

  .cell-center {
    width: 80%;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 25px;
    padding-right: 15px;
    color: #2a2e43;
    /* background-color: #fff; */
    display: flex;
    justify-content: start;
    align-items: center;
    background-image: url("https://qiniu.zdyxjx.com/minizdyxarrow.png");
    background-repeat: no-repeat;
    background-size: 5px 10px;
    background-position: 95% center;
    /* white-space: nowrap; */
    /*内容超宽后禁止换行显示*/
    /* overflow: hidden; */
    /*超出部分隐藏*/
    /* text-overflow: ellipsis; */
    /*文字超出部分以省略号显示*/
    border-bottom: 1px solid #eeeeee;
  }
  .cell-center-n {
    width: 80%;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 25px;
    padding-right: 15px;
    color: #2a2e43;
    /* background-color: #fff; */
    display: flex;
    justify-content: start;
    align-items: center;
    /* white-space: nowrap; */
    /*内容超宽后禁止换行显示*/
    /* overflow: hidden; */
    /*超出部分隐藏*/
    /* text-overflow: ellipsis; */
    /*文字超出部分以省略号显示*/
    border-bottom: 1px solid #eeeeee;
  }
  /* 图片头 */
  .goods-title {
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 25px;
    color: #78849e;
    letter-spacing: 2.5px;
  }
  // 详情图
  .goods-img-d {
    /* background-color: #fff; */
    /* min-height: 500rpx; */
    padding: 0 5px 60px 0;
    box-sizing: border-box;
    width: 100%;
    .img-d {
      display: block;
      width: 100%;
      /* height: 100%; */
    }
  }
}
/* sku弹出框*/
.sku-block {
  height: 100%;
  /* padding: 20rpx 0; */
  min-height: 200px;
  position: relative;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  /* padding-bottom: 100rpx; */
  .sku-center-block {
    height: 340px;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE */
    scrollbar-width: none; /* Firefox */
    padding: 0 0 100px 0;

    /* 单选 */
    .one-df-sku {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;

      .img {
        margin-right: 10px;
      }
    }
    .sku-radio {
      /* background-color: papayawhip; */
      text-align: left;
      padding: 10px;
    }
    .sku-radio-name {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #999999;
    }
    .radio {
      min-width: 35px;
      text-align: center;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 25px;
      color: #666666;
      display: inline-block;
      padding: 1px 5px;
      background: #eeeeee;
      border-radius: 5px;
      margin: 5px 10px;
      border: 1px solid #eeeeee;
    }
    .radio-active {
      background: #fff;
      border: 1px solid #ff5000;
      color: #ff5000;
    }

    // 步进器
    .goods-num {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      .num-title {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #999999;
        letter-spacing: 1px;
        span {
          font-size: 12px;
        }
      }
    }
  }

  .sku-header {
    margin-top: 10px;
    height: 125px;
    /* background-color: paleturquoise; */
    display: flex;
    justify-content: start;
    align-items: flex-end;
    padding: 0 10px;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
  }
  .sku-img-block {
    width: 125px;
    height: 125px;
    border-radius: 5px;
  }
  .sku-img {
    border-radius: 5px;
    width: 125px;
    height: 125px;
  }
  .sku-info {
    /* background-color: pink; */
    margin-left: 10px;
    .original-price {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #78849e;
      text-decoration: line-through;
    }
    .sku-price {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 30px;
      color: #ff5000;
    }
    .sku-desc {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 25px;
      color: #454f63;
    }
  }
  .sku-btn-block {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 47px;
    padding: 0 15px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;

    box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    .sku-btn-left {
      width: 50%;
      height: 40px;
      background: #ff510093;
      opacity: 1;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .sku-btn-right {
      // width: 50%;
      width: 100%;
      height: 40px;
      background: #ff5000;
      opacity: 1;

      // border-top-right-radius: 20px;
      // border-bottom-right-radius: 20px;
      border-radius: 20px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.btn:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(58, 204, 225, 0.7) !important;
}
.h-nav-item {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  font-size: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.8;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #eee;
}
</style>
  